import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout/Layout'
import Home from './pages/Home'
import NotFound from './pages/NotFound'
import ImageConverter from './pages/ImageConverter'
import ImageResizer from './pages/ImageResizer'
import ImageCompressor from './pages/ImageCompressor'
import PDFMerger from './pages/PDFMerger'
import PDFSplitter from './pages/PDFSplitter'
import PDFCompressor from './pages/PDFCompressor'
import JpgToPdf from './pages/JpgToPdf'
import WordToPdf from './pages/WordToPdf'
import PowerpointToPdf from './pages/PowerpointToPdf'
import ExcelToPdf from './pages/ExcelToPdf'
import HtmlToPdf from './pages/HtmlToPdf'
import PdfToJpg from './pages/PdfToJpg'
import PdfToWord from './pages/PdfToWord'
import PdfToPowerpoint from './pages/PdfToPowerpoint'
import PdfToExcel from './pages/PdfToExcel'
import PdfToPdfA from './pages/PdfToPdfA'
import About from './pages/About'
import Privacy from './pages/Privacy'
// Text Tools
import WordCounter from './pages/WordCounter'
import CharacterCounter from './pages/CharacterCounter'
import CaseConverter from './pages/CaseConverter'
import TextSorter from './pages/TextSorter'
import RemoveExtraSpaces from './pages/RemoveExtraSpaces'
import FindAndReplace from './pages/FindAndReplace'
import ReverseText from './pages/ReverseText'
import RemoveDuplicateLines from './pages/RemoveDuplicateLines'
// Developer Tools
import JsonFormatter from './pages/JsonFormatter'
import JsonCsvConverter from './pages/JsonCsvConverter'
import UuidGenerator from './pages/UuidGenerator'
import UrlEncoder from './pages/UrlEncoder'
import Base64Encoder from './pages/Base64Encoder'
import JwtDecoder from './pages/JwtDecoder'
import RegexTester from './pages/RegexTester'
import XmlJsonConverter from './pages/XmlJsonConverter'
import YamlJsonConverter from './pages/YamlJsonConverter'
// Calculator Tools
import UnitConverter from './pages/UnitConverter'
import PercentageCalculator from './pages/PercentageCalculator'
import ScientificCalculator from './pages/ScientificCalculator'
import FactorialCalculator from './pages/FactorialCalculator'
import PrimeNumberChecker from './pages/PrimeNumberChecker'
import RandomNumberGenerator from './pages/RandomNumberGenerator'
import CurrencyConverter from './pages/CurrencyConverter'
import AgeCalculator from './pages/AgeCalculator'
import BMICalculator from './pages/BMICalculator'
import DiceRoller from './pages/DiceRoller'
// Security & Encoding Tools
import HashGenerator from './pages/HashGenerator'
import PasswordGenerator from './pages/PasswordGenerator'
import PasswordStrengthChecker from './pages/PasswordStrengthChecker'
import QRCodeGenerator from './pages/QRCodeGenerator'
import BarcodeGenerator from './pages/BarcodeGenerator'
import MorseCodeConverter from './pages/MorseCodeConverter'
import ROT13Converter from './pages/ROT13Converter'
import CaesarCipherTool from './pages/CaesarCipherTool'
import FileHashChecker from './pages/FileHashChecker'
import IPLookupTool from './pages/IPLookupTool'
import WhoisLookupTool from './pages/WhoisLookupTool'
import DNSLookupTool from './pages/DNSLookupTool'
// SEO & Website Tools
import MetaTagGenerator from './pages/MetaTagGenerator'
import RobotsTxtGenerator from './pages/RobotsTxtGenerator'
import SitemapGenerator from './pages/SitemapGenerator'
import OpenGraphPreviewTool from './pages/OpenGraphPreviewTool'
import SERPSnippetPreviewTool from './pages/SERPSnippetPreviewTool'
import WebsiteUptimeChecker from './pages/WebsiteUptimeChecker'
import SSLCertificateChecker from './pages/SSLCertificateChecker'
import PageSpeedTester from './pages/PageSpeedTester'
import BrokenLinkChecker from './pages/BrokenLinkChecker'
import WordDensityAnalyzer from './pages/WordDensityAnalyzer'
import URLShortener from './pages/URLShortener'
// Social Media Tools
import InstagramProfileDownloader from './pages/InstagramProfileDownloader'
import YouTubeThumbnailDownloader from './pages/YouTubeThumbnailDownloader'
import TikTokVideoDownloader from './pages/TikTokVideoDownloader'
import TwitterThreadUnroller from './pages/TwitterThreadUnroller'
import FacebookVideoDownloader from './pages/FacebookVideoDownloader'
import HashtagGenerator from './pages/HashtagGenerator'
import SocialSharePreviewTool from './pages/SocialSharePreviewTool'
import EmojiPickerTool from './pages/EmojiPickerTool'
import StylishTextGenerator from './pages/StylishTextGenerator'
// Design & Misc Tools
import CSSBoxShadowGenerator from './pages/CSSBoxShadowGenerator'
import CSSBorderRadiusGenerator from './pages/CSSBorderRadiusGenerator'
import QRVCardGenerator from './pages/QRVCardGenerator'
import { usePageTracking } from './hooks/useAnalytics'

function App() {
  // Automatically track page views
  usePageTracking();

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/image/convert" element={<ImageConverter />} />
        <Route path="/image/resize" element={<ImageResizer />} />
        <Route path="/image/compress" element={<ImageCompressor />} />
        <Route path="/pdf/merge" element={<PDFMerger />} />
        <Route path="/pdf/split" element={<PDFSplitter />} />
        <Route path="/pdf/compress" element={<PDFCompressor />} />
        
        {/* Document to PDF Converters */}
        <Route path="/convert/jpg-to-pdf" element={<JpgToPdf />} />
        <Route path="/convert/word-to-pdf" element={<WordToPdf />} />
        <Route path="/convert/powerpoint-to-pdf" element={<PowerpointToPdf />} />
        <Route path="/convert/excel-to-pdf" element={<ExcelToPdf />} />
        <Route path="/convert/html-to-pdf" element={<HtmlToPdf />} />
        
        {/* PDF to Document Converters */}
        <Route path="/convert/pdf-to-jpg" element={<PdfToJpg />} />
        <Route path="/convert/pdf-to-word" element={<PdfToWord />} />
        <Route path="/convert/pdf-to-powerpoint" element={<PdfToPowerpoint />} />
        <Route path="/convert/pdf-to-excel" element={<PdfToExcel />} />
        <Route path="/convert/pdf-to-pdfa" element={<PdfToPdfA />} />
        
        {/* Text Tools */}
        <Route path="/text/word-counter" element={<WordCounter />} />
        <Route path="/text/character-counter" element={<CharacterCounter />} />
        <Route path="/text/case-converter" element={<CaseConverter />} />
        <Route path="/text/text-sorter" element={<TextSorter />} />
        <Route path="/text/remove-extra-spaces" element={<RemoveExtraSpaces />} />
        <Route path="/text/find-and-replace" element={<FindAndReplace />} />
        <Route path="/text/reverse-text" element={<ReverseText />} />
        <Route path="/text/remove-duplicate-lines" element={<RemoveDuplicateLines />} />
        
        {/* Developer Tools */}
        <Route path="/dev/json-formatter" element={<JsonFormatter />} />
        <Route path="/dev/json-csv-converter" element={<JsonCsvConverter />} />
        <Route path="/dev/uuid-generator" element={<UuidGenerator />} />
        <Route path="/dev/url-encoder" element={<UrlEncoder />} />
        <Route path="/dev/base64-encoder" element={<Base64Encoder />} />
        <Route path="/dev/jwt-decoder" element={<JwtDecoder />} />
        <Route path="/dev/regex-tester" element={<RegexTester />} />
        <Route path="/dev/xml-json-converter" element={<XmlJsonConverter />} />
        <Route path="/dev/yaml-json-converter" element={<YamlJsonConverter />} />
        
        {/* Calculator Tools */}
        <Route path="/calc/unit-converter" element={<UnitConverter />} />
        <Route path="/calc/percentage-calculator" element={<PercentageCalculator />} />
        <Route path="/calc/scientific-calculator" element={<ScientificCalculator />} />
        <Route path="/calc/factorial-calculator" element={<FactorialCalculator />} />
        <Route path="/calc/prime-number-checker" element={<PrimeNumberChecker />} />
        <Route path="/calc/random-number-generator" element={<RandomNumberGenerator />} />
        <Route path="/calc/currency-converter" element={<CurrencyConverter />} />
        <Route path="/calc/age-calculator" element={<AgeCalculator />} />
        <Route path="/calc/bmi-calculator" element={<BMICalculator />} />
        <Route path="/calc/dice-roller" element={<DiceRoller />} />
        
        {/* Security & Encoding Tools */}
        <Route path="/security/hash-generator" element={<HashGenerator />} />
        <Route path="/security/password-generator" element={<PasswordGenerator />} />
        <Route path="/security/password-strength-checker" element={<PasswordStrengthChecker />} />
        <Route path="/security/qr-code-generator" element={<QRCodeGenerator />} />
        <Route path="/security/barcode-generator" element={<BarcodeGenerator />} />
        <Route path="/security/morse-code-converter" element={<MorseCodeConverter />} />
        <Route path="/security/rot13-converter" element={<ROT13Converter />} />
        <Route path="/security/caesar-cipher-tool" element={<CaesarCipherTool />} />
        <Route path="/security/file-hash-checker" element={<FileHashChecker />} />
        <Route path="/security/ip-lookup-tool" element={<IPLookupTool />} />
        <Route path="/security/whois-lookup-tool" element={<WhoisLookupTool />} />
        <Route path="/security/dns-lookup-tool" element={<DNSLookupTool />} />
        
        {/* SEO & Website Tools */}
        <Route path="/seo/meta-tag-generator" element={<MetaTagGenerator />} />
        <Route path="/seo/robots-txt-generator" element={<RobotsTxtGenerator />} />
        <Route path="/seo/sitemap-generator" element={<SitemapGenerator />} />
        <Route path="/seo/open-graph-preview" element={<OpenGraphPreviewTool />} />
        <Route path="/seo/serp-snippet-preview" element={<SERPSnippetPreviewTool />} />
        <Route path="/seo/website-uptime-checker" element={<WebsiteUptimeChecker />} />
        <Route path="/seo/ssl-certificate-checker" element={<SSLCertificateChecker />} />
        <Route path="/seo/page-speed-tester" element={<PageSpeedTester />} />
        <Route path="/seo/broken-link-checker" element={<BrokenLinkChecker />} />
        <Route path="/seo/word-density-analyzer" element={<WordDensityAnalyzer />} />
        <Route path="/seo/url-shortener" element={<URLShortener />} />
        
        {/* Social Media Tools */}
        <Route path="/social/instagram-profile-downloader" element={<InstagramProfileDownloader />} />
        <Route path="/social/youtube-thumbnail-downloader" element={<YouTubeThumbnailDownloader />} />
        <Route path="/social/tiktok-video-downloader" element={<TikTokVideoDownloader />} />
        <Route path="/social/twitter-thread-unroller" element={<TwitterThreadUnroller />} />
        <Route path="/social/facebook-video-downloader" element={<FacebookVideoDownloader />} />
        <Route path="/social/hashtag-generator" element={<HashtagGenerator />} />
        <Route path="/social/social-share-preview" element={<SocialSharePreviewTool />} />
        <Route path="/social/emoji-picker" element={<EmojiPickerTool />} />
        <Route path="/social/stylish-text-generator" element={<StylishTextGenerator />} />
        
        {/* Design & Misc Tools */}
        <Route path="/design/css-box-shadow-generator" element={<CSSBoxShadowGenerator />} />
        <Route path="/design/css-border-radius-generator" element={<CSSBorderRadiusGenerator />} />
        <Route path="/design/qr-vcard-generator" element={<QRVCardGenerator />} />
        
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        
        {/* 404 - Catch all unmatched routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  )
}

export default App
